import React from 'react';
import { User } from '../types/auth';

interface HeaderProps {
  user: User | null;
  isAuthenticated: boolean;
  onSignIn: () => void;
  onSignUp: () => void;
  onProfile: () => void;
  onLogout: () => void;
}

export default function Header({
  user,
  isAuthenticated,
  onSignIn,
  onSignUp,
  onProfile,
  onLogout,
}: HeaderProps) {
  const shortDisplay = user
    ? (user.email || (user.walletAddress
        ? `${user.walletAddress.slice(0, 6)}…${user.walletAddress.slice(-4)}`
        : 'Account'))
    : null;

  return (
    <header className="app-header">
      <div className="header-brand">
        <span className="header-logo">📈</span>
        <div>
          <h1 className="header-title">SmartPredictions</h1>
          <p className="header-sub">Live Markets · Prediction Trading</p>
        </div>
      </div>
      <div className="wallet-section">
        {isAuthenticated && user ? (
          <>
            <div className="wallet-info">
              <span className="wallet-dot" aria-hidden="true" />
              <span className="address">{shortDisplay}</span>
            </div>
            <button className="nav-tab-btn" onClick={onProfile}>
              Profile
            </button>
            <button className="disconnect-btn" onClick={onLogout}>
              Logout
            </button>
          </>
        ) : (
          <>
            <button className="connect-btn" onClick={onSignIn}>
              Sign In
            </button>
            <button className="btn-outline" onClick={onSignUp}>
              Sign Up
            </button>
          </>
        )}
      </div>
    </header>
  );
}
